'use client';

import { ReactNode } from 'react';

import Link from 'next/link';

import { EVENT_NAMES, trackEvent } from '@/analytics';
import { topicPath } from '@/helpers/linkHelpers';

interface TopicCardLinkWrapperProps {
  topicSlug: string;
  children: ReactNode;
  className?: string;
}

export function TopicCardLinkWrapper({
  topicSlug,
  children,
  className,
}: TopicCardLinkWrapperProps) {
  function handleClick() {
    trackEvent(EVENT_NAMES.topic_card_click, {
      topic: topicSlug,
      path: topicPath(topicSlug),
    });
  }

  return (
    <Link
      href={topicPath(topicSlug)}
      className={className}
      onClick={handleClick}
    >
      {children}
    </Link>
  );
}
